import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppLoginComponent} from './pages/app.login.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppMainComponent} from './app.main.component';
import {AuthenticationGuard} from '@app/auth/authentication.guard';
import {RedirectorComponent} from '@shared/components/redirector/redirector.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '',
        component: AppMainComponent,
        data: {
          breadcrumb: 'Dashboard',
        },
        canActivate: [AuthenticationGuard],
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full'
          },
          {
            path: 'dashboard',
            canActivate: [AuthenticationGuard],
            // data: { breadcrumb: 'Dashboard' },
            data: {breadcrumb: {skip: true}},
            loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
          },
          {
            path: 'reserves',
            data: {breadcrumb: 'Booking'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/reserve/reserve.module').then(m => m.ReserveModule)
          },
          {
            path: 'leisure',
            data: {breadcrumb: 'Leisure'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('@app/modules/reserve-leisure/leisure.module').then(m => m.LeisureModule)
          },
          {
            path: 'transfers',
            data: {breadcrumb: 'Transfer'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/transfer/transfer.module').then(m => m.TransferModule)
          },
          {
            path: 'slots',
            data: {breadcrumb: 'Slot'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/slot/slot.module').then(m => m.SlotModule)
          },
          {
            path: 'course',
            data: {breadcrumb: 'Course'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/course/course.module').then(m => m.CourseModule)
          },
          {
            path: 'shop',
            data: {breadcrumb: 'Shop'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/shop/shop.module').then(m => m.ShopModule)
          },
          {
            path: 'supplier',
            data: {breadcrumb: 'Supplier'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/supplier/supplier.module').then(m => m.SupplierModule)
          },
          {
            path: 'package',
            data: {breadcrumb: 'Package'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/package/package.module').then(m => m.PackageModule)
          },
          {
            path: 'package-item',
            data: {breadcrumb: 'Package Item'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/package-item/package-item.module').then(m => m.PackageItemModule)
          },
          {
            path: 'coupon',
            data: {breadcrumb: 'Coupon'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/coupon/coupon.module').then(m => m.CouponModule)
          },
          {
            path: 'price-rule',
            data: {breadcrumb: 'Price Rule'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/price-rule/price-rule.module').then(m => m.PriceRuleModule)
          },
          {
            path: 'app-config',
            data: {breadcrumb: 'App-Config'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/app-config/app-config.module').then(m => m.AppConfigModule)
          },
          {
            path: 'inbox',
            data: {breadcrumb: 'Inbox'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/inbox/inbox.module').then(m => m.InboxModule)
          },
          {
            path: 'configuration',
            data: {breadcrumb: 'Configuration'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/configuration/configuration.module').then(m => m.ConfigurationModule)
          },
          {
            path: 'user',
            data: {breadcrumb: 'User'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule)
          },
          // {
          //     path: 'vouchers',
          //     data: {breadcrumb: 'Voucher'},
          //     canActivate: [AuthenticationGuard],
          //     loadChildren: () => import('./modules/vouchers/vouchers.module').then(m => m.VouchersModule)
          // },
          {
            path: 'voucher',
            data: {breadcrumb: 'Voucher'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/voucher/voucher.module').then(m => m.VoucherModule)
          },
          {
            path: 'portal',
            data: {breadcrumb: 'Portal'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/portal/portal.module').then(m => m.PortalModule)
          },
          {
            path: 'rewards',
            data: {breadcrumb: 'Reward'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/reward/reward.module').then(m => m.RewardModule)
          },
          {
            path: 'report',
            data: {breadcrumb: 'Report'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/report/report.module').then(m => m.ReportModule)
          },
          {
            path: 'monitor',
            data: {breadcrumb: 'Monitor'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/monitor/monitor.module').then(m => m.MonitorModule)
          },
          {
            path: 'settings',
            data: {breadcrumb: 'Settings'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule)
          },
          {
            path: 'utilities',
            data: {breadcrumb: 'Utilities'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/utilities/utilities.module').then(m => m.UtilitiesModule)
          },
          {
            path: 'top-golf',
            data: {breadcrumb: 'Top Golf'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/top-golf/top-golf.module').then(m => m.TopGolfModule)
          },
          {path: 'redirector', component: RedirectorComponent},
          {
            path: 'golf-bag',
            data: {breadcrumb: 'Golf Bag'},
            canActivate: [AuthenticationGuard],
            loadChildren: () => import('./modules/golfBag/golfBag.module').then(m => m.GolfBagModule)
          },
          // {path: '', component: DashboardDemoComponent},
          // {path: 'uikit/formlayout', component: FormLayoutDemoComponent},
          // {path: 'uikit/floatlabel', component: FloatLabelDemoComponent},
          // {path: 'uikit/invalidstate', component: InvalidStateDemoComponent},
          // {path: 'uikit/input', component: InputDemoComponent},
          // {path: 'uikit/button', component: ButtonDemoComponent},
          // {path: 'uikit/table', component: TableDemoComponent},
          // {path: 'uikit/list', component: ListDemoComponent},
          // {path: 'uikit/tree', component: TreeDemoComponent},
          // {path: 'uikit/panel', component: PanelsDemoComponent},
          // {path: 'uikit/overlay', component: OverlaysDemoComponent},
          // {path: 'uikit/menu', loadChildren: () => import('./demo/view/menus/menus.module').then(m => m.MenusModule)},
          // {path: 'uikit/media', component: MediaDemoComponent},
          // {path: 'uikit/message', component: MessagesDemoComponent},
          // {path: 'uikit/misc', component: MiscDemoComponent},
          // {path: 'uikit/charts', component: ChartsDemoComponent},
          // {path: 'uikit/file', component: FileDemoComponent},
          // {path: 'utilities/icons', component: IconsComponent},
          // {path: 'pages/crud', component: AppCrudComponent},
          // {path: 'pages/calendar', component: AppCalendarComponent},
          // {path: 'pages/timeline', component: AppTimelineDemoComponent},
          // {path: 'pages/invoice', component: AppInvoiceComponent},
          // {path: 'pages/help', component: AppHelpComponent},
          // {path: 'pages/empty', component: EmptyDemoComponent},
          // {path: 'documentation', component: DocumentationComponent},
          // {path: 'blocks', component: BlocksComponent},
        ]
      },
      {path: 'error', component: AppErrorComponent},
      {path: 'access', component: AppAccessdeniedComponent},
      {path: 'notfound', component: AppNotfoundComponent},
      {path: 'login', component: AppLoginComponent},
      // {path: '**', redirectTo: '/notfound'},
    ], {scrollPositionRestoration: 'enabled'})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
